import { Contact } from '../interfaces/contacts.interface';
import { createAction, props } from '@ngrx/store';

export const SET_CONTACTS  = '[CONTACTS] Set'
export const setContacts = createAction( SET_CONTACTS , props<{contacts: Contact[]}>());
